<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-switch`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.69727 6.62941C2.42193 6.62955 2.19824 6.85307 2.19824 7.12844C2.19859 7.40352 2.42214 7.62635 2.69727 7.62649H8.10059L7.28125 8.44582C7.0868 8.64062 7.08658 8.95623 7.28125 9.1509C7.47593 9.34536 7.7916 9.34528 7.98633 9.1509L9.65625 7.48098C9.79883 7.3384 9.8417 7.12334 9.76465 6.93703C9.6874 6.75078 9.50536 6.62941 9.30371 6.62941H2.69727ZM4.71973 2.85305C4.52494 2.6584 4.20938 2.65832 4.01465 2.85305L2.34473 4.52297C2.20234 4.66561 2.15919 4.88068 2.23633 5.06691C2.3136 5.25295 2.4958 5.37443 2.69727 5.37453H9.30371C9.57903 5.37453 9.80252 5.15078 9.80273 4.87551C9.80261 4.60017 9.57908 4.37746 9.30371 4.37746H3.90039L4.71973 3.55813C4.91448 3.36338 4.91442 3.04783 4.71973 2.85305Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineSwitch',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
